import * as React from 'react'
import styled from 'styled-components'

const NO_HIGHLIGHT = 'no-highlight'

const Highlight = styled.span`
  color: ${({ theme }) => theme.colors.grey};
  font-family: 'Times New Roman';
  font-size: ${({ theme }) => theme.font.text.size.lg};
  line-height: 26px;
  background-color: rgba(235, 113, 0, 0.3);

  .${NO_HIGHLIGHT} {
    background-color: ${({ theme }) => theme.colors.white};
  }
`

const AlignLeft = styled.div`
  text-align: left;
`

// String regions surrounded by double parens should be rendered without highlight.
//  For example in "My dog ((has)) fleas", "has" should not have a highlight
//  applied, while the remaining text regions should have highlight.
export const mapStringHighlightRegions = (
  inputText: string,
  mapped: React.ReactNode[] = []
): React.ReactNode[] => {
  const doubleParensRegex = /\(\(([^)]+)\)\)/g
  const currentMatch = doubleParensRegex.exec(inputText)

  if (currentMatch) {
    mapped.push(...formatRegions(inputText, currentMatch))
    return mapStringHighlightRegions(inputText.slice(doubleParensRegex.lastIndex), mapped)
  }

  mapped.push(inputText)
  return mapped
}

const formatRegions = (input: string, match: RegExpExecArray) => {
  const regions = []

  const highlight = input.slice(0, match.index)
  if (highlight) {
    regions.push(highlight)
  }

  regions.push(
    <span key={match[1]} className={NO_HIGHLIGHT}>
      {match[1]}
    </span>
  )
  return regions
}

const MatchedHighlighter: React.FunctionComponent<{ matched: string }> = ({
  matched,
}) => {
  const mappedRegions = mapStringHighlightRegions(matched)
  return (
    <AlignLeft>
      <Highlight>{mappedRegions}</Highlight>
    </AlignLeft>
  )
}

export default MatchedHighlighter



// WEBPACK FOOTER //
// ./src/components/Modals/PlagiarismSourcesModal/TextHighlight.tsx